<template>
	<div class="jm-page">
		<div class="jm-back" @click="back">
			<i class="el-icon-arrow-left"></i>
			<div class="jm-back-text">返回</div>
		</div>
		<!-- 上方空白占位 -->
		<div class="jm-spacer" v-if="!settings.isStart">
			<span>每10分钟进线 3 名客户</span>
			<el-button type="primary" @click="$refs.productModal.handleStart()">开始</el-button>
			<span>实操练习疑问，或者问题反馈的途径：<br> 去手机上打开淘金云客服APP→点击”消息”→进”在线技能提升培训群”反馈</span>
		</div>
		<div class="jm-spacer" v-else>
			<span>实操练习疑问，或者问题反馈的途径：<br> 去手机上打开淘金云客服APP→点击”消息”→进”在线技能提升培训群”反馈</span>
			<el-button v-if="hasProducts" type="danger" @click="$refs.productModal.showProducts()">产品须知</el-button>
			<div style="display: flex;align-items: center;gap: 10px;">
				<span style="font-weight: bold;color: black;">推荐回复</span>
				<el-switch v-model="settings.isRecommendReply" @change="changeRecommendReply"/>
			</div>
			<div style="font-size: 20px;font-weight: bold;color: black;">{{ formattedTime }}</div>
			<el-button type="warning" @click="stopTrain">退出</el-button>
			<span>回复数：{{ totalReplyCount }} 打字速度：{{ typingSpeedWPM }}字/分钟 <br>首次响应时间：{{ firstResponseAvgSec }}秒 平均响应时间：{{ avgResponseSec }}秒</span>
		</div>
		<!-- 下方 1311 x 751 容器（相对定位） -->
		<div class="jm-container">
			<!-- 使用等宽高图片作为背景，不直接设置在容器上 -->
			<img class="jm-bg" src="@/assets/images/jingmai/jingmai_chat.png" alt="" />
			<!-- 业务内容写在这里 -->
			<div class="jm-content">
				<el-select v-model="settings.onlineStatus" placeholder="请选择" class="status-select">
					<el-option label="接待" value="1"></el-option>
					<el-option label="离线" value="2"></el-option>
					<el-option label="挂起" value="3"></el-option>
				</el-select>
				<div class="train-session-list">
					<div
						class="ts-item"
						v-for="s in (settings.trainSession || [])"
						:key="s.id || s.veruser"
						:class="{ current: s.isCurrent, replied: !s.isCurrent && !s.didReply }"
						@click="selectSession(s)"
					>
						<img src="@/assets/images/jingmai/monitorPhoto.png" class="ts-avatar"/>
						<div class="ts-name">{{ s.veruser }}</div>
					</div>
				</div>
				<div class="current-user" v-if="currentSession">
					<div class="ts-item normal">
						<img src="@/assets/images/jingmai/monitorPhoto.png" class="ts-avatar"/>
						<div class="ts-name">{{ currentSession.veruser }}</div>
					</div>
				</div>
				<div class="chat-msg-content" v-if="currentSession" ref="chatContent">
					<div class="chat-msg-list">
						<div v-for="(msg, idx) in currentMessages" :key="msg.id || idx" class="msg-item" >
							<img src="@/assets/images/jingmai/monitorPhoto.png" class="msg-avatar"/>
							<div class="msg-main">
								<div class="msg-header">
									<span class="msg-name">{{ msg.fromName || '对方' }}</span>
									<span class="msg-time">{{ formatMsgTime(msg.sendTime) }}</span>
								</div>
								<order-msg-card
									v-if="msg.questionType === '卡片' && findOrderById(msg.questionOrderId)"
									:order="findOrderById(msg.questionOrderId)"
									platform="jingmai"
								/>
								<template v-else>
									<div class="msg-text" v-html="msg.question"></div>
									<img v-if="msg.questionImg" :src="msg.questionImg" class="msg-image" />
								</template>
								<div class="ref-title"  @click="msg.fold = !msg.fold">{{ msg.fold ? '查看参考答案' : '收起参考答案' }}</div>
                                <div class="msg-reference" v-if="!msg.fold">
                                    <div class="ref-label">参考回复：</div>
                                    <div
                                        class="ref-body"
                                        v-html="msg.answer"
                                        @copy.prevent
                                        @cut.prevent
                                        @contextmenu.prevent
                                        @selectstart.prevent
                                        @dragstart.prevent
                                    ></div>
                                </div>
								<div class="reply-list" v-if="(msg.replyList || []).length">
									<div class="reply-item" v-for="(rep, rIdx) in msg.replyList" :key="rep.id || rIdx">
										<div class="msg-header right">
											<span class="msg-time">{{ formatMsgTime(rep.sendTime) }}</span>
											<img src="@/assets/images/jingmai/monitorPhoto.png" class="msg-avatar"/>
										</div>
										<div class="msg-text msg-rich">
											<template v-for="(node, nIdx) in parseContent(rep.content)">
												<img v-if="node.type==='img'" :key="'img-'+nIdx" :src="node.src" class="msg-image" />
												<span v-else :key="'txt-'+nIdx" style="display: block;">{{ node.text }}</span>
											</template>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="chat-msg-toolbar">
					<el-button type="primary" size="small" @click="closeSession">关闭会话</el-button>
					<el-button type="primary" size="small" @click="sendReply">发送</el-button>
				</div>
				<div class="chat-msg-input">
					<el-input
						type="textarea"
						v-model="replyText"
						:rows="6"
						placeholder="请输入回复内容..."
						resize="none"
						class="reply-textarea"
						@keydown.native="onReplyKeydown"
						@input="onReplyInput"
						@paste.native="onReplyPaste"
					></el-input>
				</div>
				<!-- 快捷短语提示框 -->
				<div v-if="showQuickReplySuggestions" class="quick-reply-suggestions">
						<div 
							v-for="(item, index) in quickReplySuggestions" 
							:key="item.id"
							class="suggestion-item"
							:class="{ active: index === selectedSuggestionIndex }"
							@click="selectSuggestion(item)"
							@mouseenter="selectedSuggestionIndex = index"
						>
							<span class="suggestion-text">个</span>
							<span class="suggestion-code">{{ item.quicktext }}</span>
							<span class="suggestion-content">{{ item.replytext }}</span>
						</div>
				</div>
				<el-input v-model="keyword" placeholder="搜索短语" clearable class="keyword-input"
					@input="onKeywordInput"></el-input>
				<div class="fast-reply-content">
					<div class="fr-group" v-for="g in filteredFastReplyList" :key="g.id">
						<div class="fr-group-header" @click="toggleGroup(g.id)" @contextmenu.prevent="onGroupContext($event, g)">
							<i :class="settings.collapsedGroups[g.id] ? 'el-icon-caret-right' : 'el-icon-caret-bottom'"></i>
							<span class="fr-group-title">{{ g.name }} ({{ (g.filteredReplyList || []).length }}/100)</span>
						</div>
						<div v-show="!settings.collapsedGroups[g.id]" class="fr-group-body">
							<div class="fr-item" v-for="r in (g.filteredReplyList || [])" :key="r.id" @click="onClickReply(r)" @contextmenu.prevent="onReplyContext($event, r, g)">
								<span class="fr-quick">{{ r.quicktext }}</span>
								<span class="fr-text">{{ r.replytext }}</span>
							</div>
						</div>
					</div>
				</div>
				<!-- 右键菜单 -->
				<div v-if="menu.visible" class="fr-menu" :style="{ left: menu.x + 'px', top: menu.y + 'px' }">
					<!-- 分组菜单 -->
					<template v-if="menu.type === 'group'">
						<div class="fr-menu-item" @click="menuAddGroup">添加分组</div>
						<div class="fr-menu-item" @click="menuEditGroup">修改</div>
						<div class="fr-menu-item danger" @click="menuDeleteGroup">删除</div>
						<div class="fr-menu-item" @click="menuAddReply">添加短语</div>
						<div class="fr-menu-item" @click="menuCollapseAll">收起所有</div>
					</template>
					<!-- 短语菜单 -->
					<template v-else-if="menu.type === 'reply'">
						<div class="fr-menu-item" @click="menuEditReplyGroup">修改分组</div>
						<div class="fr-menu-item" @click="menuAddReply">添加短语</div>
						<div class="fr-menu-item" @click="menuEditReply">修改</div>
						<div class="fr-menu-item danger" @click="menuDeleteReply">删除</div>
					</template>
				</div>
				<div class="fast-reply-actionbars">
					<el-tooltip content="刷新" placement="bottom">
						<div class="action-item" @click="refreshFastReply"></div>
					</el-tooltip>
					<el-tooltip content="新建" placement="bottom">
						<div class="action-item" @click="newFastReply"></div>
					</el-tooltip>
					<el-tooltip content="导入" placement="bottom">
						<div class="action-item" @click="showImport = true"></div>
					</el-tooltip>
					<el-tooltip content="导出" placement="bottom">
						<div class="action-item"></div>
					</el-tooltip>
					<el-tooltip content="下载" placement="bottom">
						<div class="action-item"></div>
					</el-tooltip>
				</div>
				<div class="orders-list" v-if="matchedOrder">
					<div class="order-card">
						<div class="order-top">
							<div class="order-no">订单编号：{{ orderHeader.orderNo }} <i class="el-icon-document-copy copy-icon"></i></div>
							<div class="order-time">下单时间：{{ orderHeader.orderTime }} <br><span class="pay-time">付款时间：{{ orderHeader.orderPayTime }}</span></div>
						</div>
						<div class="order-header">
							<div class="order-price">¥ {{ matchedOrder.price.toFixed(2) }}</div>
							<div class="order-meta">数量：{{ matchedOrder.num }}</div>
							<div class="order-status">{{ matchedOrder.status }}</div>
						</div>
						<div class="order-body">
							<img class="order-img" :src="matchedOrder.imgurl" alt="商品图" />
							<div class="order-info">
								<div class="order-title" :title="matchedOrder.productName">{{ matchedOrder.productName }}</div>
								<div class="order-sku">SKU：{{ matchedOrder.size || '(无)' }}</div>
								<div class="order-pay">支付：<span class="price">¥ {{ (matchedOrder.price * matchedOrder.num).toFixed(2) }}</span></div>
							</div>
						</div>
						<div class="order-footer">
							<div class="order-row">收件人：{{ matchedOrder.name }}</div>
							<div class="order-row">电话：{{ matchedOrder.phone }}</div>
							<div class="order-row">地址：{{ matchedOrder.address }}</div>
						</div>
					</div>
				</div>
				<FastReplyImportDialog :sceneId="sceneId" :visible.sync="showImport" @refresh="refreshFastReply" />
				<FastReplyEditorDialog :sceneId="sceneId" :visible.sync="showEditor" :defaultGroupId="settings.defaultGroupId" :value="editorValue" @refresh="refreshFastReply" />
				<TrainScoreDialog :result="trainResult" :visible.sync="showScore" @onRestart="restartTrain" @onViewResult="viewResult" />
			</div>
		</div>
		<CourseProductModal ref="productModal" :course-id="sceneId" @confirm="startTrain" @products-fetched="hasProducts = $event" />
	</div>
</template>

<script>
import FastReplyImportDialog from './components/FastReplyImportDialog.vue'
import FastReplyEditorDialog from './components/FastReplyEditorDialog.vue'
import TrainScoreDialog from './components/TrainScoreDialog.vue'
import orders from '@/page/train/FBT/data/order'
import OrderMsgCard from './components/OrderMsgCard.vue'
import CourseProductModal from './components/CourseProductModal.vue'
export default {
	name: 'jingmaiChat',
	data() {
		return {
			sceneId: this.$route.query.sceneId,
			hasProducts: false,
			settings: {
				isStart: false,
				onlineStatus: '1',
				isRecommendReply: false,
				time: 0,
				collapsedGroups: {},
				groups: [],
				defaultGroupId: null,
				trainId: null,
				trainSession:[],
				isMaxSession: false,
			},
			timer: null,
			taskATimer: null,
			taskBTimer: null,
			taskCTimer: null,
			keyword: '',
			showImport: false,
			showEditor: false,
			showScore: false,
			trainResult: null,
			editorValue: null,
			// 外部订单数据：jingmai
			ordersJingmai: orders.jingmai,
			
			menu: { visible: false, x: 0, y: 0, group: null, reply: null, type: 'group' },
			fastReplyList: [],
			replyText: '',
			fullLoading: null,
			showQuickReplySuggestions: false,
			quickReplySuggestions: [],
			selectedSuggestionIndex: 0,
			// 打字速度（实用口径 + 粘贴修正）
			typingStartMs: null,
			typingAccumMs: 0,
			typedCharsTotal: 0,
			pastedCharsCurrent: 0,
			// 订单头部展示信息
			orderHeader: { orderNo: '', orderTime: '', orderPayTime: '' },
			
		};
	},
	components: { FastReplyImportDialog, FastReplyEditorDialog, TrainScoreDialog, OrderMsgCard, CourseProductModal },
	mounted() {
		this.refreshFastReply();
		// 生成随机订单号和下单时间（早于昨天）
		this.generateOrderHeader();
	},
	beforeDestroy() {
		// 组件销毁前清理所有定时器，防止内存泄漏
		if (this.timer) { clearInterval(this.timer); this.timer = null; }
		if (this.taskATimer) { clearInterval(this.taskATimer); this.taskATimer = null; }
		if (this.taskBTimer) { clearInterval(this.taskBTimer); this.taskBTimer = null; }
		if (this.taskCTimer) { clearInterval(this.taskCTimer); this.taskCTimer = null; }
		if (this.fullLoading) { this.fullLoading.close(); this.fullLoading = null; }
	},
	watch: {
		matchedOrder: {
			handler(newVal, oldVal) {
				if (newVal && !oldVal) {
					this.generateOrderHeader();
				}
			}
		}
	},
	computed: {
		matchedOrder() {
			const session = this.currentSession;
			if (!session || !Array.isArray(session.quesList) || !session.quesList.length) return null;
			// 取当前对方发出的最后一个问题（已送达：sendTime 存在）的 questionOrderId
			let lastDelivered = null;
			for (let i = session.quesList.length - 1; i >= 0; i--) {
				const q = session.quesList[i];
				if (q && q.sendTime && q.questionOrderId) { lastDelivered = q; break; }
			}
			if (!lastDelivered) return null;
			const list = this.ordersJingmai || [];
			return list.find(o => String(o.id) === String(lastDelivered.questionOrderId)) || null;
		},
		formattedTime() {
			const t = Math.max(0, this.settings.time | 0);
			const m = String(Math.floor(t / 60)).padStart(2, '0');
			const s = String(t % 60).padStart(2, '0');
			return `00:${m}:${s}`;
		},
		currentSession() {
			return (this.settings.trainSession || []).find(s => s.isCurrent) || null;
		},
		currentMessages() {
			if (!this.currentSession) return [];
			var messages = [];
			this.currentSession.quesList.forEach(q => {
				if (q.sendTime) {
					console.log('[order-card]', { questionType: q.questionType, questionOrderId: q.questionOrderId, matched: !!this.findOrderById(q.questionOrderId), q: q });
					messages.push(q);
				}
			});
			return messages;
		},
		totalReplyCount() {
			let count = 0;
			(this.settings.trainSession || []).forEach(s => {
				(s.quesList || []).forEach(q => {
					if (Array.isArray(q.replyList)) {
						count += q.replyList.length;
					}
				});
			});
			return count;
		},
		firstResponseAvgSec() {
			const sessions = this.settings.trainSession || [];
			const deltas = [];
			sessions.forEach(s => {
				const firstQ = (s.quesList || [])[0];
				if (!firstQ || !firstQ.sendTime) return;
				const firstReply = (firstQ.replyList || []).find(r => r && r.sendTime);
				if (!firstReply) return;
				const deltaMs = Number(firstReply.sendTime) - Number(firstQ.sendTime);
				if (isFinite(deltaMs) && deltaMs >= 0) {
					deltas.push(deltaMs);
				}
			});
			if (!deltas.length) return 0;
			const avgMs = deltas.reduce((a,b) => a + b, 0) / deltas.length;
			return Math.round(avgMs / 1000);
		},
		avgResponseSec() {
			const sessions = this.settings.trainSession || [];
			const deltas = [];
			sessions.forEach(s => {
				(s.quesList || []).forEach(q => {
					if (!q || !q.sendTime) return;
					const firstReply = (q.replyList || []).find(r => r && r.sendTime);
					if (!firstReply) return;
					const deltaMs = Number(firstReply.sendTime) - Number(q.sendTime);
					if (isFinite(deltaMs) && deltaMs >= 0) {
						deltas.push(deltaMs);
					}
				});
			});
			if (!deltas.length) return 0;
			const avgMs = deltas.reduce((a,b) => a + b, 0) / deltas.length;
			return Math.round(avgMs / 1000);
		},
		typingSpeedWPM() {
			const ms = Number(this.typingAccumMs) || 0;
			const chars = Number(this.typedCharsTotal) || 0;
			if (ms <= 0 || chars <= 0) return 0;
			const minutes = ms / 60000;
			if (minutes <= 0) return 0;
			return Math.round(chars / minutes);
		},
		filteredFastReplyList() {
			if (!this.keyword || !this.keyword.trim()) {
				// 无关键词时返回原始数据，展开所有分组
				return (this.fastReplyList || []).map(g => ({
					...g,
					filteredReplyList: g.replyList || []
				}));
			}
			
			const keyword = this.keyword.trim().toLowerCase();
			return (this.fastReplyList || []).map(g => {
				const filtered = (g.replyList || []).filter(r => {
					const quicktext = (r.quicktext || '').toLowerCase();
					const replytext = (r.replytext || '').toLowerCase();
					return quicktext.includes(keyword) || replytext.includes(keyword);
				});
				
				return {
					...g,
					filteredReplyList: filtered
				};
			}).filter(g => g.filteredReplyList.length > 0); // 只显示有匹配项的分组
		}
	},
	methods: {
		// 根据 questionOrderId 匹配本地订单数据，用于聊天流订单卡片
		findOrderById(orderId) {
			const list = this.ordersJingmai || [];
			let order = (orderId != null && orderId !== '') ? list.find(o => String(o.id) === String(orderId)) : null;
			// 匹配不到用 1101 兜底
			return order || list.find(o => String(o.id) === '1101') || null;
		},
		sendReply() {
			const text = (this.replyText || '').trim();
			if(!text || !this.currentSession){
				this.$message({ type: 'error', message: '请先选择一个会话' });
				return;
			}
			if(text.length > 2000){
				this.$message({ type: 'warning', message: '消息内容过长，请控制在2000字符以内' });
				return;
			}
			let target = null;
			const list = Array.isArray(this.currentSession.quesList) ? this.currentSession.quesList : [];
			for (let i = list.length - 1; i >= 0; i--) {
				const q = list[i];
				if (q && q.sendTime) { target = q; break; }
			}
			if (!target) { this.$message({ type: 'warning', message: '暂无可回复的问题' }); return; }
			if (!Array.isArray(target.replyList)) { this.$set(target, 'replyList', []); }
			const now = Date.now();
			if (this.typingStartMs) {
				this.typingAccumMs += Math.max(0, now - this.typingStartMs);
			}
			const effectiveChars = Math.max(0, text.length - (this.pastedCharsCurrent || 0));
			this.typedCharsTotal += effectiveChars;
			const localMinutes = ((this.typingStartMs ? (now - this.typingStartMs) : 0) || 0) / 60000;
			const localSpeed = localMinutes > 0 ? Math.round(effectiveChars / localMinutes) : 0;
			this.typingStartMs = null;
			this.pastedCharsCurrent = 0;
			target.replyList.push({ id: 'local-' + Date.now(), from: 'self', fromName: '', sendTime: now, content: text });
			this.sendMsg(0,text,localSpeed,'','',target.id,this.currentSession && this.currentSession.id);
			this.replyText = '';
			this.$nextTick(() => { this.scrollChatToBottom(); });
		},
		generateOrderHeader() {
			const pad = (n) => String(n).padStart(2, '0');
			// 订单号：年月日时分秒 + 随机4位
			const now = new Date();
			const no = `${now.getFullYear()}${pad(now.getMonth()+1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}${Math.floor(1000+Math.random()*9000)}`;
			// 时间：在昨天之前的随机时间
			const todayStart = new Date();
			todayStart.setHours(0,0,0,0);
			const yesterdayStart = new Date(todayStart.getTime() - 24*60*60*1000);
			const threeDaysAgo = new Date(yesterdayStart.getTime() - 3*24*60*60*1000);
			const ts = threeDaysAgo.getTime() + Math.random() * (yesterdayStart.getTime() - threeDaysAgo.getTime() - 1);
			const dt = new Date(ts);
			const timeStr = `${dt.getFullYear()}-${pad(dt.getMonth()+1)}-${pad(dt.getDate())} ${pad(dt.getHours())}:${pad(dt.getMinutes())}:${pad(dt.getSeconds())}`;
			// 付款时间：下单后 1-15 分钟内
			const payDeltaMin = 1 + Math.floor(Math.random()*15);
			const payDt = new Date(dt.getTime() + payDeltaMin*60*1000);
			const payStr = `${payDt.getFullYear()}-${pad(payDt.getMonth()+1)}-${pad(payDt.getDate())} ${pad(payDt.getHours())}:${pad(payDt.getMinutes())}:${pad(payDt.getSeconds())}`;
			this.orderHeader.orderNo = no;
			this.orderHeader.orderTime = timeStr;
			this.orderHeader.orderPayTime = payStr;
		},
		watchMatchedOrder(newVal, oldVal) {
			if (newVal && !oldVal) {
				this.generateOrderHeader();
			}
		},
		onReplyKeydown(e){
			console.log('onReplyKeydown called:', e.key, e.shiftKey, this.replyText);
			
			// 处理快捷短语选择；如果是回车且有建议，优先选择建议；否则继续走发送
			if (this.showQuickReplySuggestions) {
				if (e.key === 'ArrowDown') {
					e.preventDefault();
					this.selectedSuggestionIndex = Math.min(this.selectedSuggestionIndex + 1, this.quickReplySuggestions.length - 1);
					return;
				}
				if (e.key === 'ArrowUp') {
					e.preventDefault();
					this.selectedSuggestionIndex = Math.max(this.selectedSuggestionIndex - 1, 0);
					return;
				}
				if (e.key === 'Enter' && this.quickReplySuggestions.length > 0) {
					e.preventDefault();
					if (this.quickReplySuggestions[this.selectedSuggestionIndex]) {
						this.selectSuggestion(this.quickReplySuggestions[this.selectedSuggestionIndex]);
					}
					return;
				}
				if (e.key === 'Escape') {
					e.preventDefault();
					this.hideSuggestions();
					return;
				}
			}
			
			if(e.key === 'Enter' && !e.shiftKey){
				console.log('Enter key detected, processing send...');
				e.preventDefault();
				this.sendReply();
			}
		},
		onClickReply(item){
			if(!item) return;
			const text = (item.replytext || '').trim();
			if(!text) return;
			// 将快捷短语填充到输入框，若已有内容则在末尾追加换行
			if(this.replyText){
				this.replyText = this.replyText.replace(/\s*$/, '') + '\n' + text;
			}else{
				this.replyText = text;
			}
			this.$nextTick(() => {
				const ta = this.$el.querySelector('.reply-textarea textarea');
				if(ta){ ta.focus(); ta.selectionStart = ta.selectionEnd = this.replyText.length; }
			});
		},
		back() {
			this.$router.back();
		},
		changeRecommendReply() {
			this.settings.trainSession.forEach(s => {
				s.quesList.forEach(q => {
					q.fold = !this.settings.isRecommendReply;
				});
			});
		},
		startTrain() {
			this.settings.isStart = true;
			this.settings.time = 60 * 10; // 10分钟
			if (this.timer) clearInterval(this.timer);
			if (this.taskATimer) clearInterval(this.taskATimer);
			if (this.taskBTimer) clearInterval(this.taskBTimer);
			if (this.taskCTimer) clearInterval(this.taskCTimer);
			this.timer = setInterval(() => {
				if (this.settings.time > 0) {
					this.settings.time -= 1;
					if (this.settings.time == 60 * 7) {
						this.newSession();
						this.startTaskB();
					}
					if (this.settings.time == 60 * 4) {
						this.newSession();
						this.startTaskC();
						this.settings.isMaxSession = true;
					}
				} else {
					clearInterval(this.timer);
					this.timer = null;
					if (this.settings.trainSession.length == 0) {
						this.submitTrain();
					}else{
						this.$alert('已经不会有客户进线了，接待完客户依次关闭对话即可评分', '训练结束', {
							confirmButtonText: '确定',
							type: 'info'
						});
					}
				}
			}, 1000);
			// 初始化与任务定时器
			this.$http.get(API_ROOT.newcustomer + '/train/initTrain?exam=0&sessionnum=3&dependid=' + this.sceneId).then(res => {
				const result = res.data;
				if (result && result.success) {
					this.settings.trainId = result.data.trainId;
					this.newSession();
					this.startTaskA();
				} else {
					this.$message({ type: 'error', message: result.msg || '开始训练失败' });
				}
			});
		},
		startTaskA(){
			// 独立的任务定时器：不随倒计时结束而停止
			if (this.taskATimer) { clearInterval(this.taskATimer); this.taskATimer = null; }
			this.taskATimer = setInterval(() => {
				console.log('taskATimer');
				// 从 trainSession 找第一个元素
				const sessions = this.settings.trainSession || [];
				if (!sessions.length) return;
				const firstSession = sessions[0];
				const quesList = Array.isArray(firstSession.quesList) ? firstSession.quesList : [];
				if (!quesList.length) return;
				// 找到最后一个 sendTime != null 且 replyList 不为空 的元素索引
				let idx = -1;
				for (let i = quesList.length - 1; i >= 0; i--) {
					const q = quesList[i];
					if (q && q.sendTime && Array.isArray(q.replyList) && q.replyList.length > 0) { idx = i; break; }
				}
				if (idx === -1) return;
				console.log('idx',idx);
				const nextIdx = idx + 1;
				if (nextIdx >= quesList.length) return;
				const nextQ = quesList[nextIdx];
				console.log('nextQ',nextQ.answer);
				if (!nextQ) return;
				// 若下一题尚未"送达"，则激活它
				if (!nextQ.sendTime) {
					nextQ.sendTime = Date.now();
					// 触发一条“对方”消息，用于保持与新会话一致的行为
					this.sendMsg(1, '', 0, nextQ.answer, firstSession.veruser, nextQ.id, firstSession.id);
					if (!firstSession.isCurrent) {
						firstSession.didReply = false;
					}
				}
			}, 15000);
		},
		startTaskB(){
			if (this.taskBTimer) { clearInterval(this.taskBTimer); this.taskBTimer = null; }
			this.taskBTimer = setInterval(() => {
				console.log('taskBTimer');
				// 从 trainSession 找第一个元素
				const sessions = this.settings.trainSession || [];
				if (!sessions.length || sessions.length <= 1) return;
				const secondSession = sessions[1];
				const quesList = Array.isArray(secondSession.quesList) ? secondSession.quesList : [];
				if (!quesList.length) return;
				// 找到最后一个 sendTime != null 且 replyList 不为空 的元素索引
				let idx = -1;
				for (let i = quesList.length - 1; i >= 0; i--) {
					const q = quesList[i];
					if (q && q.sendTime && Array.isArray(q.replyList) && q.replyList.length > 0) { idx = i; break; }
				}
				if (idx === -1) return;
				const nextIdx = idx + 1;
				if (nextIdx >= quesList.length) return;
				const nextQ = quesList[nextIdx];
				if (!nextQ) return;
				// 若下一题尚未"送达"，则激活它
				if (!nextQ.sendTime) {
					nextQ.sendTime = Date.now();
					// 触发一条“对方”消息，用于保持与新会话一致的行为
					this.sendMsg(1, '', 0, nextQ.answer, secondSession.veruser, nextQ.id, secondSession.id);
					if (!secondSession.isCurrent) {
						secondSession.didReply = false;
					}
				}
			}, 15000);
		},
		startTaskC(){
			if (this.taskCTimer) { clearInterval(this.taskCTimer); this.taskCTimer = null; }
			this.taskCTimer = setInterval(() => {
				console.log('taskCTimer');
				// 从 trainSession 找第一个元素
				const sessions = this.settings.trainSession || [];
				if (!sessions.length || sessions.length <= 2) return;
				const thirdSession = sessions[2];
				const quesList = Array.isArray(thirdSession.quesList) ? thirdSession.quesList : [];
				if (!quesList.length) return;
				// 找到最后一个 sendTime != null 且 replyList 不为空 的元素索引
				let idx = -1;
				for (let i = quesList.length - 1; i >= 0; i--) {
					const q = quesList[i];
					if (q && q.sendTime && Array.isArray(q.replyList) && q.replyList.length > 0) { idx = i; break; }
				}
				if (idx === -1) return;
				const nextIdx = idx + 1;
				if (nextIdx >= quesList.length) return;
				const nextQ = quesList[nextIdx];
				if (!nextQ) return;
				// 若下一题尚未"送达"，则激活它
				if (!nextQ.sendTime) {
					nextQ.sendTime = Date.now();
					// 触发一条“对方”消息，用于保持与新会话一致的行为
					this.sendMsg(1, '', 0, nextQ.answer, thirdSession.veruser, nextQ.id, thirdSession.id);
					if (!thirdSession.isCurrent) {
						thirdSession.didReply = false;
					}
				}
			}, 15000);
		},
		closeSession(){
			if (!this.currentSession) return;
			const currentIndex = this.settings.trainSession.findIndex(s => s.id === this.currentSession.id);
			if (currentIndex === -1) return;

			// 检查是否存在未下发或未回复的问题
			const quesList = Array.isArray(this.currentSession.quesList) ? this.currentSession.quesList : [];
			const hasPending = quesList.some(q => !q || (!q.sendTime) || (q.sendTime && (!Array.isArray(q.replyList) || q.replyList.length === 0)));

			const doRemove = () => {
				// 移除当前会话
				this.settings.trainSession.splice(currentIndex, 1);
				// 如果数组中还有会话，选择下一个（或前一个）
				if (this.settings.trainSession.length > 0) {
					const nextIndex = currentIndex < this.settings.trainSession.length ? currentIndex : currentIndex - 1;
					this.selectSession(this.settings.trainSession[nextIndex]);
				} else {
					// 如果没有会话了，清空当前会话
					this.settings.trainSession=[];
					if(this.settings.isMaxSession){
						// 如果已经达到最大会话数，则停止训练
						if (this.settings.time <= 0) {
							this.submitTrain();
						}
					}
				}
			};

			if (hasPending) {
				this.$confirm('当前会话您还有未回复的问题，确定关闭会话？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					doRemove();
				}).catch(() => {});
			} else {
				doRemove();
			}
		},
		submitTrain(){
			this.openFullLoading('提交中...');
			this.$http.post(API_ROOT.newcustomer + '/train/submitTrain', { id: this.settings.trainId }).then(res => {
				const result = res.data;
				if (result && result.success) {
					this.getScorById();
				} else {
					this.$message({ type: 'error', message: result.msg || '提交失败' });
					this.closeFullLoading();
				}
			}, () => {
				this.$message({ type: 'error', message: '提交失败' });
				this.closeFullLoading();
			})
		},
		getScorById(){
			const self = this;
			this.$http.post(API_ROOT.newcustomer + '/train/getById', { id: this.settings.trainId }).then(res => {
				const result = res.data;
				if (result && result.success) {
					self.closeFullLoading();
					self.trainResult = result.data;
					self.showScore = true;
				}else {
					this.$message({ type: 'error', message: result.msg || '提交失败' });
					self.closeFullLoading();
				}
			}, () => {
				this.$message({ type: 'error', message: '提交失败' });
				this.closeFullLoading();
			})
		},
		openFullLoading(text) {
			if (this.fullLoading) { this.fullLoading.close(); this.fullLoading = null; }
			this.fullLoading = this.$loading({
				lock: true,
				text: text || '加载中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.4)'
			});
		},
		closeFullLoading() {
			if (this.fullLoading) { this.fullLoading.close(); this.fullLoading = null; }
		},
		newSession(){
			this.$http.post(API_ROOT.newcustomer + '/train/newSession', { id: this.settings.trainId, batchId:this.$route.query.batchId}).then(res => {
				const result = res.data;
				if (result && result.success) {
					const item = result.data.trainSession[0];
					if (this.settings.trainSession.length == 0) {
						item.isCurrent = true;
						item.didReply = true;
					} else {
						item.isCurrent = false;
						item.didReply = false;
					}
					item.quesList.forEach(q => {
						q.fromName = item.veruser;
						q.sendTime = null;
						q.fold = true;
						q.replyList = [];
					});
					item.quesList[0].sendTime = Date.now();
					this.settings.trainSession.push(item);
					this.sendMsg(1,'',0,item.quesList[0].answer,item.veruser,item.quesList[0].id,item.id);
					this.$nextTick(() => { this.scrollChatToBottom(); });
				} else {
					this.$message({ type: 'error', message: result.msg || '开始训练失败' });
				}
			});
		},
		sendMsg(role,content,typingspeed,sysanswer,username,questionId,sessionId){
			console.log('sendMsg called with:', {role, content, typingspeed, sysanswer, username, questionId, sessionId});
			var data
			if(role === 1){
				data = {
					role: 1,
					content: '',
					typingspeed: 0,
					sysanswer: sysanswer,
					username: username,
					questionId: questionId,
					sessionid: sessionId || (this.currentSession && this.currentSession.id)
				}
			}else{
				data = {
					role: 0,
					content: content,
					typingspeed: typingspeed,
					questionId: questionId,
					sessionid: sessionId || (this.currentSession && this.currentSession.id)
				}
			}
			console.log('Sending data to API:', data);
			this.$http.post(API_ROOT.newcustomer + '/train/sendMsg', data).then(res => {
				const result = res.data;
				if (result && result.success) {
					
				} else {
					this.$message({ type: 'error', message: result.msg || '发送失败' });
				}
			}).catch(err => {
				console.error('发送消息失败:', err);
				this.$message({ 
					type: 'error', 
					message: '网络错误，发送失败。请检查网络连接或稍后重试。' 
				});
			});
			this.$nextTick(() => { this.scrollChatToBottom(); });
		},
		selectSession(target){
			(this.settings.trainSession || []).forEach(s => {
				s.isCurrent = false;
			});
			target.isCurrent = true;
			target.didReply = true;
			this.$nextTick(() => { this.scrollChatToBottom(); });
		},
		stopTrain() {
			this.settings = {
				isStart: false,
				onlineStatus: '1',
				isRecommendReply: false,
				time: 0,
				collapsedGroups: {},
				groups: [],
				defaultGroupId: null,
				trainId: null,
				trainSession:[],
				isMaxSession: false,
			},
			// 重置打字统计
			this.typingStartMs = null;
			this.typingAccumMs = 0;
			this.typedCharsTotal = 0;
			this.pastedCharsCurrent = 0;
			clearInterval(this.timer);
			this.timer = null;
			if (this.taskATimer) { clearInterval(this.taskATimer); this.taskATimer = null; }
			if (this.taskBTimer) { clearInterval(this.taskBTimer); this.taskBTimer = null; }
			if (this.taskCTimer) { clearInterval(this.taskCTimer); this.taskCTimer = null; }
		},
		restartTrain() {
			this.showScore = false;
			this.stopTrain();
			this.$refs.productModal.handleStart();
		},
		viewResult() {
			this.$router.push({
				name: 'fbtTrainResult',
				query: {
					trainId: this.settings.trainId
				}
			});
			this.showScore = false;
			this.stopTrain();
		},
		onKeywordInput() {
			// 实时筛选逻辑在 computed 中处理
		},
		onReplyInput() {
			// 进入输入状态的起点：从空到非空
			const textNow = this.replyText || '';
			if (!this.typingStartMs && textNow.trim().length > 0) {
				this.typingStartMs = Date.now();
			}
			// 检测是否输入了 / 符号
			const text = this.replyText || '';
			const lastSlashIndex = text.lastIndexOf('/');
			
			if (lastSlashIndex !== -1) {
				// 获取 / 后面的内容作为搜索关键词
				const searchKeyword = text.substring(lastSlashIndex + 1).toLowerCase();
				
				if (searchKeyword.length === 0) {
					// 如果只输入了 /，显示所有快捷短语
					this.showAllQuickReplies();
				} else {
					// 根据关键词筛选快捷短语
					this.filterQuickReplies(searchKeyword);
				}
			} else {
				// 没有 / 符号，隐藏提示框
				this.hideSuggestions();
			}
			// 若清空输入，则结束当前输入段并清零本段粘贴统计
			if (textNow.trim().length === 0) {
				if (this.typingStartMs) {
					// 不累计时间（只有发送时累计），仅重置起点
					this.typingStartMs = null;
				}
				this.pastedCharsCurrent = 0;
			}
		},
		onReplyPaste(e) {
			try {
				const text = (e.clipboardData && e.clipboardData.getData('text')) || '';
				this.pastedCharsCurrent += (text || '').length;
			} catch (err) { /* ignore */ }
		},
		showAllQuickReplies() {
			const allReplies = [];
			(this.fastReplyList || []).forEach(group => {
				(group.replyList || []).forEach(reply => {
					allReplies.push(reply);
				});
			});
			this.quickReplySuggestions = allReplies.slice(0, 6); // 最多显示6个
			this.selectedSuggestionIndex = 0;
			this.showQuickReplySuggestions = true;
		},
		filterQuickReplies(keyword) {
			const filteredReplies = [];
			(this.fastReplyList || []).forEach(group => {
				(group.replyList || []).forEach(reply => {
					const quicktext = (reply.quicktext || '').toLowerCase();
					const replytext = (reply.replytext || '').toLowerCase();
					if (quicktext.includes(keyword) || replytext.includes(keyword)) {
						filteredReplies.push(reply);
					}
				});
			});
			this.quickReplySuggestions = filteredReplies.slice(0, 6); // 最多显示6个
			this.selectedSuggestionIndex = 0;
			this.showQuickReplySuggestions = true;
		},
		selectSuggestion(item) {
			if (!item) return;
			
			const text = this.replyText || '';
			const lastSlashIndex = text.lastIndexOf('/');
			
			if (lastSlashIndex !== -1) {
				// 替换 / 及其后面的内容为选中的快捷短语
				const beforeSlash = text.substring(0, lastSlashIndex);
				this.replyText = beforeSlash + item.replytext;
			} else {
				// 如果没有 / 符号，直接添加
				this.replyText = text + item.replytext;
			}
			
			this.hideSuggestions();
			
			// 聚焦到输入框
			this.$nextTick(() => {
				const textarea = this.$el.querySelector('.reply-textarea textarea');
				if (textarea) {
					textarea.focus();
					textarea.setSelectionRange(this.replyText.length, this.replyText.length);
				}
			});
		},
		hideSuggestions() {
			this.showQuickReplySuggestions = false;
			this.quickReplySuggestions = [];
			this.selectedSuggestionIndex = 0;
		},
		refreshFastReply() {
			this.$http.get(API_ROOT.newcustomer + '/train/reply/searchType?id=' + this.sceneId).then(res => {
				const result = res.data;
				if (result && result.success) {
					this.settings.groups = Array.isArray(result.data.personalType) ? result.data.personalType : [];
				}
			});
			this.$http.post(API_ROOT.newcustomer + '/train/reply/search?type=1&sceneId=' + this.sceneId).then(res => {
				const result = res.data;
				if (result && result.success) {
					this.fastReplyList = result.data.typeList;
				} else {
					this.$message({
						message: result.msg,
						type: 'error'
					});
				}
			}, err => {
				this.$message({
					message: '保存失败',
					type: 'error'
				});
			})
		},
		newFastReply() {
			this.showEditor = true;
		},
		toggleGroup(id) {
			if (!this.settings.collapsedGroups) this.$set(this.settings, 'collapsedGroups', {});
			this.$set(this.settings.collapsedGroups, id, !this.settings.collapsedGroups[id]);
		},
		onGroupContext(e, group) {
			this.menu.visible = true;
			const rect = this.$el.getBoundingClientRect();
			this.menu.x = e.clientX - rect.left;
			this.menu.y = e.clientY - rect.top - 110;
			this.menu.group = group;
			this.menu.type = 'group';
			document.addEventListener('click', this.hideMenuOnce, { once: true });
		},
		onReplyContext(e, reply, group) {
			this.menu.visible = true;
			const rect = this.$el.getBoundingClientRect();
			this.menu.x = e.clientX - rect.left;
			this.menu.y = e.clientY - rect.top - 110;
			this.menu.reply = reply;
			this.menu.group = group;
			this.menu.type = 'reply';
			document.addEventListener('click', this.hideMenuOnce, { once: true });
		},
		hideMenuOnce() {
			this.menu.visible = false;
			this.menu.group = null;
			this.menu.reply = null;
			this.menu.type = 'group';
		},
		menuAddGroup() {
			this.menu.visible = false;
			const self = this;
			this.$prompt('请输入分组名', '新增分组', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				inputPattern: /\S+/, // 非空
				inputErrorMessage: '分组名不能为空'
			}).then(({ value }) => {
				const name = value && value.trim();
				if (!name) return;
				this.$http.post(API_ROOT.newcustomer + '/train/reply/saveReplyType?sceneId=' + self.sceneId, { name :name }).then(res => {
					const result = res.data;
					if (result && result.success) {
						this.$message({ type: 'success', message: '保存分组成功' });
						self.refreshFastReply();
					} else {
						this.$message({ type: 'error', message: result.msg || '保存失败' });
					}
				}, () => {
					this.$message({ type: 'error', message: '保存失败' });
				});
			});
		},
		menuEditGroup() {
			const group = this.menu.group;
			this.menu.visible = false;
			const self = this;
			this.$prompt('请输入分组名', '编辑分组', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				inputPattern: /\S+/, // 非空
				inputErrorMessage: '分组名不能为空',
				inputValue: group && group.name ? group.name : ''
			}).then(({ value }) => {
				const name = value && value.trim();
				if (!name) return;
				this.$http.post(API_ROOT.newcustomer + '/train/reply/saveReplyType?sceneId=' + self.sceneId, { name :name, id: group.id }).then(res => {
					const result = res.data;
					if (result && result.success) {
						this.$message({ type: 'success', message: '保存分组成功' });
						self.refreshFastReply();
					} else {
						this.$message({ type: 'error', message: result.msg || '保存失败' });
					}
				}, () => {
					this.$message({ type: 'error', message: '保存失败' });
				});
			});
		},
		/**
		 * 修改短语分组
		 */
		menuEditReplyGroup() {
			const reply = this.menu.reply;
			const currentGroup = this.menu.group;
			this.menu.visible = false;
			const self = this;
			
			// 创建分组选择弹窗
			const h = this.$createElement;
			const selectVNode = h('el-select', {
				props: {
					value: currentGroup ? currentGroup.id : '',
					placeholder: '请选择分组'
				},
				on: {
					input: (value) => {
						selectVNode.componentInstance.value = value;
					}
				}
			}, this.settings.groups.map(group => 
				h('el-option', {
					props: {
						key: group.id,
						label: group.name,
						value: group.id
					}
				})
			));
			
			this.$msgbox({
				title: '修改分组',
				message: h('div', [
					h('p', { style: 'margin-bottom: 10px;' }, '请选择新的分组：'),
					selectVNode
				]),
				showCancelButton: true,
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				beforeClose: (action, instance, done) => {
					if (action === 'confirm') {
						const selectedGroupId = selectVNode.componentInstance.value;
						if (!selectedGroupId) {
							this.$message({ type: 'warning', message: '请选择分组' });
							return;
						}
						const group = self.settings.groups.find(g => g.id === selectedGroupId);
						// 调用修改分组接口
						this.$http.post(API_ROOT.newcustomer + '/train/reply/saveReply', {
							type: group.type,
							typeid: selectedGroupId,
							quicktext: reply.quicktext,
							replytext: reply.replytext,
							id: reply.id
						}).then(res => {
							const result = res.data;
							if (result && result.success) {
								this.$message({ type: 'success', message: '修改分组成功' });
								self.refreshFastReply();
								done();
							} else {
								this.$message({ type: 'error', message: result.msg || '修改失败' });
							}
						}, () => {
							this.$message({ type: 'error', message: '修改失败' });
						});
					} else {
						done();
					}
				}
			});
		},
		/**
		 * 删除分组
		 */
		menuDeleteGroup() {
			const group = this.menu.group;
			this.menu.visible = false;
			const self = this;
			this.$http.post(API_ROOT.newcustomer + '/train/reply/deleteReplyType?id=' + group.id).then(res => {
					const result = res.data;
					if (result && result.success) {
						this.$message({ type: 'success', message: '删除成功' });
						self.refreshFastReply();
					} else {
						this.$message({ type: 'error', message: result.msg || '删除失败' });
					}
				}, () => {
					this.$message({ type: 'error', message: '删除失败' });
				});
		},
		/**
		 * 添加短语
		 */
		menuAddReply() {
			this.settings.defaultGroupId = this.menu.group ? this.menu.group.id : null;
			this.menu.visible = false;
			this.showEditor = true;
		},
		menuCollapseAll() {
			this.menu.visible = false;
			const map = {};
			(this.fastReplyList || []).forEach(g => { map[g.id] = true; });
			this.$set(this.settings, 'collapsedGroups', map);
		},
		menuEditReply() {
			this.menu.visible = false;
			const reply = this.menu.reply || {};
			// 将当前短语的数据映射到编辑弹窗所需字段
			const groupId = (this.menu.group && this.menu.group.id) ? this.menu.group.id : '';
			this.settings.defaultGroupId = groupId;
			this.editorValue = {
				id: reply.id || '',
				content: reply.replytext || '',
				group: groupId,
				code: reply.quicktext || ''
			};
			this.showEditor = true;
		},
		menuDeleteReply() {
			this.menu.visible = false;
			const reply = this.menu.reply;
			const self = this;
			this.$confirm('确定要删除这条快捷短语吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http.post(API_ROOT.newcustomer + '/train/reply/deleteReply', { id: reply.id }).then(res => {
					const result = res.data;
					if (result && result.success) {
						this.$message({ type: 'success', message: '删除成功' });
						self.refreshFastReply();
					} else {
						this.$message({ type: 'error', message: result.msg || '删除失败' });
					}
				}, () => {
					this.$message({ type: 'error', message: '删除失败' });
				});
			}).catch(() => {
				this.$message({ type: 'info', message: '已取消删除' });
			});
		},
		formatMsgTime(t) {
			if (!t) return '';
			const date = typeof t === 'number' ? new Date(t) : new Date(String(t));
			const y = date.getFullYear();
			const M = String(date.getMonth() + 1).padStart(2, '0');
			const d = String(date.getDate()).padStart(2, '0');
			const h = String(date.getHours()).padStart(2, '0');
			const m = String(date.getMinutes()).padStart(2, '0');
			const s = String(date.getSeconds()).padStart(2, '0');
			return `${y}-${M}-${d} ${h}:${m}:${s}`;
		},
		scrollChatToBottom() {
			const el = this.$refs && this.$refs.chatContent;
			if (!el) return;
			try {
				el.scrollTop = el.scrollHeight;
			} catch (e) { /* ignore */ }
		},
		parseContent(content) {
			// 识别普通图片链接（含查询参数），并进行图文混排
			// 匹配形如 http(s)://.../xxx.(png|jpg|jpeg|gif|webp|bmp)[?...] 的链接
			const urlRegex = /(https?:\/\/[^\s]+?\.(?:png|jpe?g|gif|webp|bmp)(?:\?[^\s]*)?)/ig;
			const nodes = [];
			const str = String(content || '');
			let lastIndex = 0;
			let match;
			while ((match = urlRegex.exec(str)) !== null) {
				const start = match.index;
				if (start > lastIndex) {
					nodes.push({ type: 'text', text: str.slice(lastIndex, start) });
				}
				nodes.push({ type: 'img', src: match[1] });
				lastIndex = urlRegex.lastIndex;
			}
			if (lastIndex < str.length) {
				nodes.push({ type: 'text', text: str.slice(lastIndex) });
			}
			return nodes.length ? nodes : [{ type: 'text', text: str }];
		},
		onClickReply(reply) {
			this.replyText = reply.replytext;
		}
	}
};
</script>

<style lang='less' scoped>
/* 页面根容器，居中显示 1311px 布局 */
.jm-page {
	width: 1448px;
	margin: 0 auto;
	box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
	background: #fff;
	border-radius: 8px;
	padding-top: 15px;
}

.jm-back {
	display: flex;
	flex-direction: row;
	align-items: center;
	cursor: pointer;
	width: 100px;
	margin-left: 8px;
	margin-bottom: 10px;

	.el-icon-arrow-left {
		margin-right: 10px;
	}
}

.jm-back-text {
	margin-left: 0;
}

/* 上方空白占位，可根据需要调整高度 */
.jm-spacer {
	height: 60px;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 20px;

	background-color: rgb(246, 246, 246);
}

/* 相对定位的容器，固定 1311 x 751 */
.jm-container {
	position: relative;
	width: 1448px;
	height: 917px;
	overflow: hidden;
}

/* 等宽高图片，用作“背景”，不直接写到容器样式上 */
.jm-bg {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height:817px;
	object-fit: cover;
	pointer-events: none;
}

/* 业务内容容器，覆盖在背景图上层 */
.jm-content {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	.status-select {
		position: absolute;
		width: 65px;
		left: 130px;
		top: 62px;
		height: 25px;

		/deep/ .el-input__inner {
			height: 25px;
			line-height: 25px;
			padding: 0 24px 0 8px;
			font-size: 13px;
			border: none;
			box-shadow: none;
			border-color: transparent;
		}

		/deep/ .el-input.is-focus .el-input__inner,
		/deep/ .el-input__inner:focus,
		/deep/ .el-input__inner:hover {
			border: none !important;
			box-shadow: none !important;
			border-color: transparent !important;
		}

		/deep/ .el-input__icon {
			line-height: 25px;
		}
	}

	.keyword-input {
		position: absolute;
		width: 200px;
		left: 830px;
		top: 103px;
		height: 25px;

		/deep/ .el-input__inner {
			height: 25px;
			line-height: 25px;
			padding: 0 22px 0 8px;
			/* 预留右侧空白给清空按钮 */
			font-size: 13px;
			background-color: #F7F7F7;
			border: none;
			box-shadow: none;
			border-color: transparent;
		}

		/* 调整清空按钮位置与垂直居中 */
		/deep/ .el-input__suffix {
			right: 4px;
			height: 25px;
			display: flex;
			align-items: center;
		}

		/deep/ .el-input__clear {
			line-height: 25px;
			height: 25px;
		}

		/deep/ .el-input.is-focus .el-input__inner,
		/deep/ .el-input__inner:focus,
		/deep/ .el-input__inner:hover {
			border: none !important;
			box-shadow: none !important;
			border-color: transparent !important;
		}
	}
	.chat-msg-input {
		position: absolute;
		width: 460px;
		height: 152px;
		left: 343px;
		top: 622px;
		background: #F7F7F7;

	}
	.reply-textarea {
		/deep/ .el-textarea__inner {
			height: 100% !important;
			min-height: 100% !important;
			max-height: 100% !important;
			background: #F7F7F7;
			border: none;
			box-shadow: none;
			font-size: 14px;
			line-height: 22px;
		}
	}

	.chat-msg-toolbar {
		position: absolute;
		left: 652px;
		top: 777px;
		display: flex;
		background: #F7F7F7;
	}
	.orders-list {
		position: absolute;
		width: 360px;
		height: 433px;
		right: 5px;
		top: 178px;
		background: #F0F0F0;
		padding: 10px;
		box-sizing: border-box;
	}
	.order-card { background: #fff; border-radius: 6px; padding: 10px; display: flex; flex-direction: column; }
	.order-top { display: flex; flex-direction: column; gap: 4px; font-size: 12px; color: #666; margin-bottom: 6px; background: #f7f8fa; border-radius: 4px; padding: 6px 8px; }
	.copy-icon { color: #999; font-size: 12px; margin-left: 6px; }
	.order-time { font-size: 12px; }
	.order-time .pay-time {color: #666; }
	.order-header { display: flex; align-items: center; gap: 8px; margin-bottom: 10px; }
	.order-price { color: #e1251b; font-size: 18px; font-weight: 700; }
	.order-meta { color: #666; font-size: 12px; }
	.order-status { margin-left: auto; color: #52c41a; font-size: 12px; }
	.order-body { display: flex; gap: 10px; }
	.order-img { width: 86px; height: 86px; object-fit: cover; border-radius: 4px; background: #f5f5f5; }
	.order-info { flex: 1; display: flex; flex-direction: column; gap: 6px; }
	.order-title { font-size: 13px; color: #333; line-height: 18px; height: 36px; overflow: hidden; display: -webkit-box; -webkit-line-clamp: 2; line-clamp: 2; -webkit-box-orient: vertical; }
	.order-sku { color: #888; font-size: 12px; }
	.order-pay .price { color: #e1251b; font-weight: 600; }
	.order-footer { margin-top: auto; padding-top: 10px; font-size: 12px; color: #666; display: flex; flex-direction: column; gap: 4px; }
	.chat-msg-content {
		position: absolute;
		width: 460px;
		height: 433px;
		left: 342px;
		top: 147px;
		background: #F7F7F7;
		overflow: auto;
	}
	.chat-msg-list { padding: 12px; }
	.msg-item { display: flex; margin-bottom: 14px; justify-content: flex-start; width: 100%;}
	.msg-avatar { width: 32px; height: 32px; margin-right: 8px; border-radius: 50%; }
	.msg-main { width: 100%; }
	.msg-header { color: #999; font-size: 12px; margin-bottom: 6px; }
	.msg-name { margin-right: 8px; color: #666; }
	.msg-text { color: #333; font-size: 14px; line-height: 22px; }
	.msg-image {
		max-width: 300px;
		margin-top: 10px;
		border-radius: 4px;
		object-fit: cover;
	}
	.ref-title { color: red; margin-bottom: 6px; margin-top: 20px; cursor: pointer; }
	.msg-reference { background: #E9F4FF; border-radius: 6px; padding: 10px 12px; }
	.msg-reference .ref-label { color: #F56C6C; margin-bottom: 4px; }
	.msg-reference .ref-body {
		background: #fff; 
		border-radius: 4px; 
		padding: 10px 12px; 
		color: #E84C3D; 
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
	}
	.reply-list { margin-top: 10px; display: flex; flex-direction: column; gap: 8px; }
	.reply-item { display: flex; flex-direction: column; justify-content: flex-end; align-items: flex-end;}
    .reply-item .msg-text { color: #333; font-size: 14px; line-height: 22px; text-align: start; margin-right: 42px;max-width: 300px;}

	.msg-header.right { text-align: right; margin-bottom: 4px; }
	.fast-reply-content {
		position: absolute;
		width: 275px;
		height: 600px;
		left: 805px;
		top: 176px;
		overflow: auto;
	}
	.train-session-list {
		position: absolute;
		width: 275px;
		height: 600px;
		left: 65px;
		top: 163px;
		overflow: auto;
		background-color: #FDFDFD;
		border-radius: 8px;
		padding: 8px;
		
	}
	.current-user {
		position: absolute;
		width: 275px;
		left: 346px;
		top: 98px;
		overflow: auto;
	}

	.ts-item {
		display: flex;
		align-items: center;
		gap: 8px;
		padding: 8px;
		border-radius: 8px;
		margin-bottom: 8px;
		background: #fff;
		cursor: pointer;
	}
	.ts-item.replied { background: #FFF5CC; }
	.ts-item.current { background: #E6F0FF; }
	.ts-item.normal { background: transparent; }

	.ts-avatar {
		width: 28px;
		height: 28px;
		border-radius: 50%;
		background: #e5e6eb;
		flex: none;
	}
	.ts-name { font-size: 13px; color: #333; }
	

	/* 快捷短语分组与子项样式 */
	.fr-group { border: 1px solid #e8e8e8; border-radius: 6px; background: #fff; }
	.fr-group-header { padding: 4px 10px; cursor: pointer; user-select: none; display: flex; align-items: center; gap: 6px; background: #f7f8fa; border-bottom: 1px solid #eee; }
	.fr-group-title { font-size: 13px; font-weight: 500; color: #333; }
	.fr-group-body { padding: 6px 8px; }
	.fr-item { display: flex; gap: 6px; font-size: 12px; color: #666; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; padding: 6px 4px; border-radius: 4px; }
	.fr-item:hover { background: #f5f7fa; }
	.fr-quick { color: #2d6cf6; flex: none; }
	.fr-text { flex: 1; overflow: hidden; text-overflow: ellipsis; }

	.fast-reply-actionbars {
		position: absolute;
		width: 175px;
		height: 25px;
		left: 805px;
		bottom: 110px;
		display: flex;
	}

	.action-item {
		flex: 1 1 20%;
		height: 100%;
		cursor: pointer;
	}
}

/* 右键菜单样式 */
.fr-menu {
	position: absolute;
	z-index: 9999;
	min-width: 140px;
	background: #fff;
	border: 1px solid #eaeaea;
	box-shadow: 0 6px 18px rgba(0,0,0,0.12);
	border-radius: 6px;
	padding: 6px 0;
}
.fr-menu-item { padding: 6px 12px; font-size: 13px; color: #333; cursor: pointer; }
.fr-menu-item:hover { background: #f5f7fa; }
.fr-menu-item.danger { color: #e34d59; }
.fr-menu-item.danger:hover { background: #fff2f2; }



/* 快捷短语提示框样式 */
.quick-reply-suggestions {
	position: absolute;
	width: 400px;
	top: 550px;
	left: 454px;
	background: #fff;
	border: 1px solid #e4e7ed;
	border-radius: 4px;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	overflow-y: auto;
	z-index: 1000;
}

.suggestion-item {
	display: flex;
	align-items: center;
	padding: 8px 12px;
	cursor: pointer;
	border-bottom: 1px solid #f5f7fa;
}

.suggestion-item:last-child {
	border-bottom: none;
}

.suggestion-item:hover,
.suggestion-item.active {
	background-color: #f5f7fa;
}

.suggestion-text {
	color: #909399;
	font-size: 12px;
	margin-right: 8px;
	min-width: 20px;
	height: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #f5f7fa;
	border: 1px solid #e4e7ed;
	border-radius: 3px;
	font-weight: 500;
}

.suggestion-code {
	color: #409eff;
	font-size: 12px;
	margin-right: 8px;
	min-width: 60px;
}

.suggestion-content {
	color: #333;
	font-size: 12px;
	flex: 1;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// ./src/page/train/FBT/jingmaiChat.vue